import { render, staticRenderFns } from "./ExposedName.vue?vue&type=template&id=e38929c2&scoped=true&"
import script from "./ExposedName.vue?vue&type=script&lang=js&"
export * from "./ExposedName.vue?vue&type=script&lang=js&"
import style0 from "./ExposedName.vue?vue&type=style&index=0&id=e38929c2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e38929c2",
  null
  
)

export default component.exports